{
  "name": "Subzero",
  "ambient": 8555670,
  "light": 16120058,
  "sky": 13883868,
  "fog": 13030361,
  "fogD": 601.943118216585,
  "camPos": [-13, 93, -6],
  "spawns": [[-41, 67, -58, 0, 0, 0], [-187, 54, -238, 0, 2, 0], [-299, 54, 2, 0, 3, 0], [131, 67, -203, 0, 3, 0], [187, 67, -336, 0, 1, 0], [350, 67, -287, 0, 1, 0], [319, 86, -59, 0, 0, 0], [178, 84, -49, 0, 0, 0], [140, 84, -13, 0, 1, 0], [-162, 67, 63, 0, 0, 0]],
  "ambO": 1,
  "ambS": 5,
  "objects": [{
    "p": [-1, 64, 0],
    "s": [140, 2, 142],
    "l": 1,
    "t": 5
  }, {
    "p": [-100, 64, 50],
    "s": [58, 2, 42],
    "l": 1,
    "t": 5
  }, {
    "p": [-149, 53, 8],
    "s": [40, 13, 126],
    "l": 1,
    "t": 5
  }, {
    "p": [-139, 51, -111],
    "s": [172, 2, 130],
    "l": 1,
    "t": 5
  }, {
    "p": [-277, 51, -77],
    "s": [104, 2, 202],
    "l": 1,
    "t": 5
  }, {
    "p": [5, 64, -123],
    "s": [60, 2, 104],
    "l": 1,
    "t": 5
  }, {
    "p": [-54, 51, -143],
    "s": [58, 15, 42],
    "l": 1,
    "t": 5
  }, {
    "p": [240, 65, -325],
    "s": [132, 2, 38],
    "c": 5723991,
    "t": 11
  }, {
    "p": [213, 64, -207],
    "s": [40, 2, 63],
    "l": 1,
    "t": 5
  }, {
    "p": [213, 64, -112],
    "s": [39, 20, 37],
    "l": 1,
    "t": 5
  }, {
    "p": [-124, 51, -285],
    "s": [203, 2, 50],
    "l": 1,
    "t": 5
  }, {
    "p": [-198, 50, -218],
    "s": [38, 2, 84],
    "c": 7566195,
    "t": 1
  }, {
    "p": [343, 64, -262],
    "s": [77, 2, 72],
    "l": 1,
    "t": 5
  }, {
    "p": [343, 64, -122],
    "s": [82, 2, 217],
    "l": 1,
    "t": 5
  }, {
    "p": [327, 64, -11],
    "s": [140, 20, 129],
    "l": 1,
    "t": 5
  }, {
    "p": [-326, 11, -77],
    "s": [9, 47, 632],
    "c": 10983566,
    "t": 11
  }, {
    "p": [-2731, 11, -77],
    "s": [5362, 31, 11525],
    "l": 1,
    "c": 5203837,
    "t": 5
  }, {
    "p": [-290, 51, -217],
    "s": [78, 56, 80],
    "c": 9342330,
    "t": 10,
    "bo": 1
  }, {
    "p": [-252, 51, -178],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-328, 56, -178],
    "s": [4, 51, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-252, 51, -256],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-290, 76, -178],
    "s": [72, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-290, 103, -178],
    "s": [72, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-290, 51, -178],
    "s": [4, 70, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-252, 76, -217],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-252, 103, -217],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-268, 113, -217],
    "s": [45, 2, 84],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 7039851,
    "t": 2
  }, {
    "p": [-312, 113, -217],
    "s": [45, 2, 84],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 7039851,
    "t": 2
  }, {
    "p": [-290, 107, -217],
    "s": [77, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-290, 120, -217],
    "s": [5, 5, 89],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-267, 115, -217],
    "s": [45, 2, 84],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-313, 115, -217],
    "s": [45, 2, 84],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-290, 125, -217],
    "s": [5, 2, 89],
    "t": 5
  }, {
    "p": [-276, 51, -178],
    "s": [2, 20, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-264, 51, -178],
    "s": [2, 20, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-270, 71, -178],
    "s": [14, 2, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-290, 111, -217],
    "s": [55, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-290, 115, -217],
    "s": [34, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-290, 119, -217],
    "s": [13, 2, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-319, 56, -198],
    "s": [9, 72, 20],
    "c": 8355711,
    "t": 11
  }, {
    "p": [-234, 51, -212],
    "s": [34, 40, 96],
    "c": 8882055,
    "t": 11,
    "bo": 1
  }, {
    "p": [-151, 51, -212],
    "s": [60, 40, 96],
    "c": 8355711,
    "t": 11,
    "bo": 1
  }, {
    "p": [-186, 90, -212],
    "s": [128, 31, 94],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [-249, 91, -166],
    "s": [4, 30, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-207, 91, -166],
    "s": [4, 26, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-165, 91, -166],
    "s": [4, 26, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-123, 91, -166],
    "s": [4, 30, 4],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-217, 53, -164],
    "s": [3, 31, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-181, 53, -164],
    "s": [3, 31, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-199, 81, -164],
    "s": [33, 3, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-221, 131, -212],
    "s": [70, 3, 100],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 7894903,
    "t": 2
  }, {
    "p": [-186, 141, -212],
    "s": [7, 7, 108],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-150, 131, -212],
    "s": [73, 3, 100],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 7894903,
    "t": 2
  }, {
    "p": [-149, 134, -212],
    "s": [73, 3, 100],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-186, 148, -212],
    "s": [7, 3, 108],
    "t": 5
  }, {
    "p": [-165, 121, -166],
    "s": [4, 16, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-207, 121, -166],
    "s": [4, 17, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-186, 121, -212],
    "s": [125, 6, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-186, 127, -212],
    "s": [93, 6, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-186, 133, -212],
    "s": [60, 6, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-186, 139, -212],
    "s": [32, 4, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-135, 76, -236],
    "s": [9, 72, 20],
    "c": 5723991,
    "t": 11
  }, {
    "p": [-258, 51, -286],
    "s": [66, 58, 56],
    "c": 8029580,
    "t": 10,
    "bo": 1
  }, {
    "p": [-123, 91, -258],
    "s": [4, 30, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-249, 91, -258],
    "s": [4, 30, 4],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-207, 91, -258],
    "s": [4, 26, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-165, 91, -258],
    "s": [4, 26, 4],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-207, 121, -258],
    "s": [4, 17, 4],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-165, 121, -258],
    "s": [4, 17, 4],
    "c": 8684676,
    "t": 2
  }, {
    "p": [-226, 53, -261],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-226, 77, -288],
    "s": [4, 4, 50],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-226, 105, -288],
    "s": [4, 4, 50],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-257, 118, -287],
    "s": [72, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-257, 113, -303],
    "s": [68, 2, 32],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-257, 112, -267],
    "s": [68, 2, 40],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-258, 109, -287],
    "s": [66, 3, 56],
    "c": 8029580,
    "t": 10
  }, {
    "p": [-257, 115, -303],
    "s": [68, 2, 33],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-257, 122, -287],
    "s": [72, 2, 4],
    "t": 5
  }, {
    "p": [-258, 112, -286],
    "s": [66, 4, 38],
    "c": 8029580,
    "t": 10
  }, {
    "p": [-258, 116, -287],
    "s": [66, 3, 21],
    "c": 8029580,
    "t": 10
  }, {
    "p": [-257, 114, -266],
    "s": [68, 2, 41],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-225, 51, -271],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-225, 51, -283],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-225, 71, -277],
    "s": [2, 2, 14],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-193, 51, -329],
    "s": [66, 38, 56],
    "c": 7110518,
    "t": 10,
    "bo": 1
  }, {
    "p": [-223, 53, -302],
    "s": [4, 42, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-161, 53, -302],
    "s": [4, 42, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-192, 87, -302],
    "s": [58, 8, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-226, 53, -315],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-192, 96, -327],
    "s": [68, 2, 57],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": 5592405,
    "t": 2
  }, {
    "p": [-192, 98, -327],
    "s": [68, 2, 57],
    "l": 1,
    "r": [0.17, 0, 0],
    "t": 5
  }, {
    "p": [-193, 89, -329],
    "s": [66, 6, 56],
    "c": 7110518,
    "t": 10
  }, {
    "p": [-193, 92, -339],
    "s": [66, 3, 36],
    "c": 7110518,
    "t": 5
  }, {
    "p": [-193, 95, -347],
    "s": [66, 3, 20],
    "c": 7110518,
    "t": 10
  }, {
    "p": [-186, 51, -302],
    "s": [2, 20, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-174, 51, -302],
    "s": [2, 20, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-180, 71, -302],
    "s": [14, 2, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-216, 51, -254],
    "s": [19, 2, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-195, 51, -257],
    "s": [12, 2, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-185, 51, -254],
    "s": [8, 2, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-211, 51, -183],
    "s": [12, 2, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [-201, 51, -179],
    "s": [8, 2, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-183, 51, -182],
    "s": [8, 2, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-197, 51, -62],
    "s": [56, 57, 80],
    "c": 8878432,
    "t": 10,
    "bo": 1
  }, {
    "p": [-224, 51, -101],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-224, 51, -23],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-170, 51, -23],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-170, 51, -101],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 77, -101],
    "s": [50, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-197, 105, -101],
    "s": [50, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 105, -62],
    "s": [58, 4, 74],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 121, -62],
    "s": [65, 6, 6],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 116, -84],
    "s": [63, 2, 43],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 6710886,
    "t": 2
  }, {
    "p": [-197, 116, -40],
    "s": [63, 2, 44],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 6710886,
    "t": 2
  }, {
    "p": [-197, 118, -39],
    "s": [63, 2, 44],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-197, 118, -85],
    "s": [63, 2, 43],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-197, 127, -62],
    "s": [65, 2, 6],
    "t": 5
  }, {
    "p": [-197, 109, -62],
    "s": [56, 3, 82],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-186, 117, -212],
    "s": [122, 4, 96],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 112, -62],
    "s": [56, 3, 66],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-197, 115, -62],
    "s": [56, 4, 50],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-197, 119, -62],
    "s": [56, 4, 28],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-224, 51, -62],
    "s": [5, 71, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-170, 51, -62],
    "s": [5, 71, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-176, 92, -90],
    "s": [7, 39, 12],
    "c": 6250335,
    "t": 11
  }, {
    "p": [-225, 51, -36],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-225, 51, -48],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-225, 71, -42],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 51, 14],
    "s": [74, 72, 70],
    "c": 6320224,
    "t": 10,
    "bo": 1
  }, {
    "p": [-233, 51, -20],
    "s": [4, 73, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-233, 51, 48],
    "s": [4, 73, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [-161, 51, 48],
    "s": [4, 73, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-161, 51, -20],
    "s": [4, 73, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 53, 14],
    "s": [77, 12, 73],
    "c": 6250335,
    "t": 11
  }, {
    "p": [-160, 91, 14],
    "s": [2, 4, 64],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-197, 120, 14],
    "s": [76, 4, 64],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-160, 66, -9],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-160, 66, 3],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-160, 84, -3],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 120, -20],
    "s": [68, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 120, 48],
    "s": [68, 4, 4],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-197, 136, 14],
    "s": [5, 5, 80],
    "c": 9868950,
    "t": 2
  }, {
    "p": [-219, 130, 14],
    "s": [42, 2, 77],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-176, 130, 14],
    "s": [41, 2, 77],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-197, 124, 14],
    "s": [74, 4, 70],
    "c": 6320224,
    "t": 10
  }, {
    "p": [-176, 132, 14],
    "s": [43, 2, 77],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-219, 132, 14],
    "s": [44, 2, 77],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-197, 141, 14],
    "s": [5, 2, 80],
    "t": 5
  }, {
    "p": [-197, 128, 14],
    "s": [53, 4, 70],
    "c": 6320224,
    "t": 10
  }, {
    "p": [-197, 136, 14],
    "s": [11, 3, 70],
    "c": 6320224,
    "t": 10
  }, {
    "p": [-197, 132, 14],
    "s": [31, 4, 70],
    "c": 6320224,
    "t": 10
  }, {
    "p": [-197, 91, -20],
    "s": [68, 4, 4],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-281, 51, 64],
    "s": [96, 58, 80],
    "c": 7558742,
    "t": 10,
    "bo": 1
  }, {
    "p": [-282, 78, 25],
    "s": [88, 4, 4],
    "c": 9013641,
    "t": 2
  }, {
    "p": [-282, 120, 64],
    "s": [102, 7, 7],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [-282, 116, 43],
    "s": [100, 2, 48],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-282, 115, 87],
    "s": [100, 2, 49],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-282, 118, 42],
    "s": [100, 2, 48],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-282, 117, 88],
    "s": [100, 2, 49],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-282, 127, 64],
    "s": [102, 2, 7],
    "l": 1,
    "t": 5
  }, {
    "p": [-281, 109, 64],
    "s": [96, 4, 80],
    "c": 6903125,
    "t": 10
  }, {
    "p": [-281, 113, 64],
    "s": [96, 4, 58],
    "c": 6903125,
    "t": 10
  }, {
    "p": [-281, 117, 64],
    "s": [96, 4, 35],
    "c": 6903125,
    "t": 10
  }, {
    "p": [-281, 121, 64],
    "s": [96, 3, 15],
    "c": 6903125,
    "t": 10
  }, {
    "p": [-264, 51, 25],
    "s": [2, 22, 4],
    "c": 9013384,
    "t": 2,
    "bo": 1
  }, {
    "p": [-252, 51, 25],
    "s": [2, 22, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-258, 71, 25],
    "s": [10, 2, 4],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [-326, 58, -77],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -61],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -93],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -109],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -126],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -143],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -160],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -177],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -44],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -27],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, -10],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, 7],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 58, 24],
    "s": [5, 7, 5],
    "c": 8223868,
    "t": 11
  }, {
    "p": [-326, 61, -79],
    "s": [2, 2, 205],
    "c": 13619151,
    "t": 2,
    "bo": 1
  }, {
    "p": [-120, 51, -159],
    "s": [4, 55, 4],
    "c": 9671571,
    "t": 2,
    "bo": 1
  }, {
    "p": [-24, 51, -159],
    "s": [4, 55, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-24, 51, -265],
    "s": [4, 55, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-120, 51, -265],
    "s": [4, 55, 4],
    "c": 8026746,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, -265],
    "s": [4, 72, 5],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, -159],
    "s": [4, 72, 5],
    "c": 9211020,
    "t": 2,
    "bo": 1
  }, {
    "p": [-100, 114, -212],
    "s": [56, 3, 114],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-72, 122, -212],
    "s": [6, 6, 119],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-45, 114, -212],
    "s": [56, 3, 114],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-72, 78, -265],
    "s": [92, 4, 4],
    "c": 7697781,
    "t": 2
  }, {
    "p": [-24, 78, -212],
    "s": [4, 4, 102],
    "c": 8355711,
    "t": 2
  }, {
    "p": [-72, 78, -159],
    "s": [92, 4, 4],
    "c": 9211020,
    "t": 2
  }, {
    "p": [-120, 78, -212],
    "s": [4, 4, 102],
    "l": 1,
    "c": 8553090,
    "t": 2
  }, {
    "p": [-72, 102, -159],
    "s": [92, 4, 4],
    "c": 9539985,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 102, -265],
    "s": [92, 4, 4],
    "c": 9671571,
    "t": 2,
    "bo": 1
  }, {
    "p": [-24, 51, -212],
    "s": [5, 55, 4],
    "c": 8355711,
    "t": 2,
    "bo": 1
  }, {
    "p": [-24, 102, -212],
    "s": [4, 4, 102],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-120, 102, -212],
    "s": [4, 4, 102],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-44, 117, -212],
    "s": [56, 3, 114],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-101, 117, -212],
    "s": [56, 3, 114],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-72, 128, -212],
    "s": [6, 2, 119],
    "t": 5
  }, {
    "p": [-111, 51, -265],
    "s": [2, 23, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-99, 51, -265],
    "s": [2, 23, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-105, 72, -265],
    "s": [10, 2, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-108, 51, -356],
    "s": [102, 60, 92],
    "c": 8217957,
    "t": 10,
    "bo": 1
  }, {
    "p": [-58, 53, -311],
    "s": [4, 59, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-158, 53, -311],
    "s": [4, 59, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-158, 53, -357],
    "s": [4, 55, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-124, 53, -311],
    "s": [4, 74, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-92, 53, -311],
    "s": [4, 75, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-108, 79, -311],
    "s": [96, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-108, 108, -311],
    "s": [96, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-108, 129, -356],
    "s": [6, 6, 105],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-136, 121, -356],
    "s": [57, 3, 99],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5855577,
    "t": 2
  }, {
    "p": [-58, 108, -358],
    "s": [4, 4, 90],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-158, 108, -355],
    "s": [4, 4, 84],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [-137, 124, -356],
    "s": [57, 2, 99],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-108, 135, -356],
    "s": [6, 2, 105],
    "t": 5
  }, {
    "p": [-79, 124, -356],
    "s": [57, 2, 99],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-80, 121, -356],
    "s": [57, 3, 99],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 6052956,
    "t": 2
  }, {
    "p": [-108, 112, -356],
    "s": [102, 5, 92],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-108, 117, -356],
    "s": [77, 5, 92],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-108, 122, -356],
    "s": [49, 5, 92],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-108, 127, -356],
    "s": [22, 5, 92],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-148, 51, -311],
    "s": [2, 22, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-136, 51, -311],
    "s": [2, 22, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-142, 71, -311],
    "s": [10, 2, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-101, 51, -20],
    "s": [60, 62, 100],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [-101, 130, -20],
    "s": [5, 5, 108],
    "c": 9868950,
    "t": 2
  }, {
    "p": [-130, 51, 29],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, 29],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, -71],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-26, 51, -71],
    "s": [4, 70, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-26, 51, -121],
    "s": [4, 70, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-128, 51, -121],
    "s": [4, 70, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-78, 51, -121],
    "s": [4, 70, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-72, 51, -19],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-101, 87, 29],
    "s": [54, 4, 4],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-101, 110, 29],
    "s": [54, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-103, 91, -121],
    "s": [46, 4, 4],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-52, 91, -121],
    "s": [48, 4, 4],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-49, 91, -71],
    "s": [42, 4, 4],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-52, 117, -121],
    "s": [48, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-103, 117, -121],
    "s": [46, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-101, 87, 5],
    "s": [62, 4, 44],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-128, 91, -95],
    "s": [4, 4, 48],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-26, 117, -96],
    "s": [4, 4, 46],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-26, 91, -96],
    "s": [4, 4, 46],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-84, 122, -20],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": 4737096,
    "t": 2
  }, {
    "p": [-118, 122, -20],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, 0.53],
    "c": 4737096,
    "t": 2
  }, {
    "p": [-52, 117, -71],
    "s": [48, 4, 4],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-130, 51, -69],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-130, 51, -19],
    "s": [5, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-101, 114, -20],
    "s": [61, 4, 100],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [-101, 118, -20],
    "s": [50, 4, 100],
    "c": 6973550,
    "t": 10
  }, {
    "p": [-101, 122, -20],
    "s": [35, 4, 100],
    "c": 6973550,
    "t": 10
  }, {
    "p": [-101, 126, -20],
    "s": [22, 4, 100],
    "c": 6973550,
    "t": 10
  }, {
    "p": [-101, 130, -20],
    "s": [9, 1, 100],
    "c": 6973550,
    "t": 5
  }, {
    "p": [-119, 124, -20],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, 0.53],
    "t": 5
  }, {
    "p": [-83, 124, -20],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, -0.52],
    "t": 5
  }, {
    "p": [-101, 135, -20],
    "s": [5, 2, 108],
    "t": 5
  }, {
    "p": [-77, 51, -96],
    "s": [104, 68, 52],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [-128, 117, -95],
    "s": [4, 4, 48],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-77, 119, -96],
    "s": [104, 5, 52],
    "c": 6254184,
    "t": 10
  }, {
    "p": [-77, 129, -96],
    "s": [114, 5, 5],
    "l": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [-77, 125, -112],
    "s": [108, 2, 31],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-77, 125, -80],
    "s": [108, 2, 31],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5723991,
    "t": 2
  }, {
    "p": [-77, 127, -113],
    "s": [108, 2, 31],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-77, 127, -79],
    "s": [108, 2, 31],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-77, 134, -96],
    "s": [114, 2, 5],
    "l": 1,
    "t": 5
  }, {
    "p": [-77, 124, -96],
    "s": [104, 4, 38],
    "c": 6254184,
    "t": 10
  }, {
    "p": [-77, 128, -96],
    "s": [104, 4, 16],
    "c": 6254184,
    "t": 10
  }, {
    "p": [-46, 65, -75],
    "s": [12, 77, 6],
    "c": 10658466,
    "t": 11
  }, {
    "p": [-25, 64, -102],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-25, 64, -90],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-25, 84, -96],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-92, 53, -87],
    "s": [77, 12, 73],
    "c": 6250335,
    "t": 11
  }, {
    "p": [175, 66, -254],
    "s": [6, 5, 46],
    "c": 10983566,
    "t": 11
  }, {
    "p": [175, 103, -334],
    "s": [6, 21, 27],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [242, 66, -347],
    "s": [128, 62, 7],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [267, 66, -236],
    "s": [78, 49, 9],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 66, -328],
    "s": [6, 37, 46],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [183, 66, -212],
    "s": [38, 102, 38],
    "c": 10983566,
    "t": 11
  }, {
    "p": [239, 65, -259],
    "s": [125, 2, 38],
    "c": 5723991,
    "t": 11
  }, {
    "p": [240, 65, -292],
    "s": [123, 2, 28],
    "c": 6694952,
    "t": 5
  }, {
    "p": [-102, 66, 118],
    "s": [126, 38, 94],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [-164, 66, 72],
    "s": [4, 38, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-40, 66, 72],
    "s": [4, 38, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-102, 66, 72],
    "s": [4, 62, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-102, 100, 72],
    "s": [120, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-102, 126, 117],
    "s": [6, 6, 102],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-67, 115, 117],
    "s": [71, 3, 99],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 5263440,
    "t": 2
  }, {
    "p": [-137, 115, 117],
    "s": [69, 3, 99],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5263440,
    "t": 2
  }, {
    "p": [-137, 118, 117],
    "s": [71, 2, 99],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [-102, 132, 117],
    "s": [6, 2, 102],
    "t": 5
  }, {
    "p": [-66, 118, 117],
    "s": [71, 2, 99],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [-102, 104, 118],
    "s": [130, 6, 94],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [-102, 110, 118],
    "s": [97, 5, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-102, 115, 118],
    "s": [70, 5, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-102, 120, 118],
    "s": [43, 5, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-102, 125, 118],
    "s": [17, 3, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-127, 66, 72],
    "s": [2, 21, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-139, 66, 72],
    "s": [2, 21, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-133, 85, 72],
    "s": [10, 2, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-194, 51, 77],
    "s": [56, 49, 65],
    "c": 8878432,
    "t": 10,
    "bo": 1
  }, {
    "p": [-179, 105, 59],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": 4737096,
    "t": 2
  }, {
    "p": [-178, 107, 59],
    "s": [39, 2, 105],
    "l": 1,
    "r": [0, 0, -0.52],
    "t": 5
  }, {
    "p": [-167, 93, 60],
    "s": [4, 4, 22],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [76, 51, -141],
    "s": [84, 62, 142],
    "c": 8878432,
    "t": 10,
    "bo": 1
  }, {
    "p": [158, 62, -129],
    "s": [82, 50, 128],
    "c": 8217957,
    "t": 10,
    "bo": 1
  }, {
    "p": [-48, 92, 88],
    "s": [7, 34, 12],
    "c": 6710886,
    "t": 11
  }, {
    "p": [35, 66, -211],
    "s": [4, 48, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [117, 66, -211],
    "s": [4, 48, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 66, -71],
    "s": [4, 48, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 66, -165],
    "s": [5, 69, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 66, -117],
    "s": [5, 69, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [76, 66, -211],
    "s": [4, 48, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-197, 77, -62],
    "s": [58, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [76, 87, -211],
    "s": [78, 4, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [76, 110, -211],
    "s": [78, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 110, -141],
    "s": [4, 4, 136],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [35, 87, -141],
    "s": [4, 4, 136],
    "c": 7895160,
    "t": 2
  }, {
    "p": [76, 87, -71],
    "s": [78, 4, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [76, 110, -71],
    "s": [78, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [76, 138, -141],
    "s": [102, 6, 6],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [76, 126, -179],
    "s": [92, 3, 81],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 4605253,
    "t": 2
  }, {
    "p": [76, 126, -103],
    "s": [92, 3, 81],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 4605253,
    "t": 2
  }, {
    "p": [76, 129, -102],
    "s": [92, 2, 81],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [76, 144, -141],
    "s": [102, 2, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [76, 114, -141],
    "s": [84, 20, 47],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 134, -141],
    "s": [84, 5, 33],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 129, -180],
    "s": [92, 2, 81],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [-221, 134, -212],
    "s": [72, 3, 100],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [117, 110, -141],
    "s": [4, 4, 136],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [198, 66, -192],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [198, 66, -66],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [159, 84, -66],
    "s": [4, 51, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [198, 66, -129],
    "s": [5, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [158, 66, -158],
    "s": [85, 17, 74],
    "c": 7235166,
    "t": 11
  }, {
    "p": [117, 87, -188],
    "s": [4, 4, 42],
    "c": 7895160,
    "t": 2
  }, {
    "p": [159, 134, -129],
    "s": [5, 5, 140],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [181, 124, -129],
    "s": [50, 2, 135],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [159, 109, -66],
    "s": [74, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [159, 83, -192],
    "s": [4, 51, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [159, 109, -192],
    "s": [74, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [120, 66, -192],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [136, 126, -129],
    "s": [51, 2, 135],
    "l": 1,
    "r": [0, 0, 0.52],
    "t": 5
  }, {
    "p": [136, 124, -129],
    "s": [48, 2, 135],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [182, 126, -129],
    "s": [51, 2, 135],
    "l": 1,
    "r": [0, 0, -0.52],
    "t": 5
  }, {
    "p": [159, 139, -129],
    "s": [5, 2, 140],
    "t": 5
  }, {
    "p": [198, 109, -129],
    "s": [4, 4, 122],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [158, 112, -129],
    "s": [82, 5, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 117, -129],
    "s": [69, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 121, -129],
    "s": [55, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 125, -129],
    "s": [40, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 129, -129],
    "s": [26, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [158, 133, -129],
    "s": [13, 4, 128],
    "l": 1,
    "c": 8217957,
    "t": 10
  }, {
    "p": [34, 63, -135],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [34, 63, -147],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [34, 83, -141],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [102, 64, -212],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [96, 84, -212],
    "s": [10, 2, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [90, 64, -212],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [183, 118, -212],
    "s": [33, 102, 33],
    "c": 13812408,
    "t": 11
  }, {
    "p": [183, 219, -212],
    "s": [38, 7, 38],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 256, -212],
    "s": [3, 3, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 227, -231],
    "s": [38, 39, 3],
    "l": 1,
    "r": [0.52, 0, 0],
    "c": 6908265,
    "t": 2
  }, {
    "p": [183, 227, -192],
    "s": [38, 39, 3],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": 6908265,
    "t": 2
  }, {
    "p": [203, 227, -212],
    "s": [3, 39, 38],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [163, 227, -212],
    "s": [3, 39, 38],
    "l": 1,
    "r": [0, 0, -0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [183, 227, -212],
    "s": [37, 11, 29],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 238, -212],
    "s": [37, 6, 23],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 244, -212],
    "s": [37, 6, 16],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 250, -212],
    "s": [37, 6, 9],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 256, -212],
    "s": [37, 5, 3],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 227, -212],
    "s": [31, 11, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 238, -212],
    "s": [24, 6, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 244, -212],
    "s": [17, 6, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 250, -212],
    "s": [10, 6, 37],
    "c": 10983566,
    "t": 11
  }, {
    "p": [183, 118, -212],
    "s": [36, 102, 10],
    "c": 9341833,
    "t": 2
  }, {
    "p": [183, 118, -212],
    "s": [11, 102, 36],
    "c": 9341833,
    "t": 2
  }, {
    "p": [183, 259, -212],
    "s": [3, 3, 41],
    "c": 5066061,
    "t": 2
  }, {
    "p": [183, 259, -212],
    "s": [40, 3, 3],
    "c": 5066061,
    "t": 2
  }, {
    "p": [161, 228, -212],
    "s": [2, 39, 38],
    "l": 1,
    "r": [0, 0, -0.52],
    "t": 5
  }, {
    "p": [205, 228, -212],
    "s": [2, 39, 38],
    "l": 1,
    "r": [0, 0, 0.52],
    "t": 5
  }, {
    "p": [183, 228, -233],
    "s": [38, 39, 2],
    "l": 1,
    "r": [0.52, 0, 0],
    "t": 5
  }, {
    "p": [183, 228, -190],
    "s": [38, 39, 2],
    "l": 1,
    "r": [-0.52, 0, 0],
    "t": 5
  }, {
    "p": [183, 262, -212],
    "s": [3, 2, 41],
    "t": 5
  }, {
    "p": [183, 262, -212],
    "s": [40, 2, 3],
    "t": 5
  }, {
    "p": [183, 162, -212],
    "s": [42, 7, 42],
    "c": 8220776,
    "bo": 1
  }, {
    "p": [183, 169, -212],
    "s": [42, 2, 42],
    "t": 5
  }, {
    "p": [183, 65, -212],
    "s": [40, 69, 40],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 65, -347],
    "s": [9, 68, 10],
    "c": 6050122,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 65, -237],
    "s": [9, 67, 10],
    "c": 6379345,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 120, -329],
    "s": [9, 5, 26],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [199, 115, -236],
    "s": [39, 9, 12],
    "c": 6575952,
    "t": 11,
    "bo": 1
  }, {
    "p": [239, 120, -347],
    "s": [119, 9, 10],
    "c": 7563104,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 66, -304],
    "s": [6, 44, 80],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 66, -245],
    "s": [6, 40, 6],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [287, 65, -292],
    "s": [29, 10, 49],
    "c": 9013641,
    "t": 2
  }, {
    "p": [271, 65, -292],
    "s": [3, 8, 24],
    "c": 9013641,
    "t": 2
  }, {
    "p": [265, 65, -292],
    "s": [3, 4, 24],
    "c": 9013641,
    "t": 2
  }, {
    "p": [268, 65, -292],
    "s": [3, 6, 24],
    "c": 9013641,
    "t": 2
  }, {
    "p": [273, 65, -316],
    "s": [3, 11, 3],
    "l": 1,
    "c": 7039851,
    "t": 2
  }, {
    "p": [273, 65, -268],
    "s": [3, 11, 3],
    "l": 1,
    "c": 7039851,
    "t": 2
  }, {
    "p": [234, 70, -260],
    "s": [7, 1, 25],
    "c": 3616550,
    "t": 5
  }, {
    "p": [234, 67, -273],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [234, 67, -247],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [239, 70, -324],
    "s": [7, 1, 25],
    "c": 3616550,
    "t": 5
  }, {
    "p": [207, 71, -324],
    "s": [1, 5, 25],
    "pe": 1,
    "c": 3616550,
    "t": 5
  }, {
    "p": [231, 71, -260],
    "s": [1, 5, 25],
    "pe": 1,
    "c": 3616550,
    "t": 5
  }, {
    "p": [239, 67, -311],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [239, 67, -337],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [210, 70, -324],
    "s": [7, 1, 25],
    "c": 3616550,
    "t": 5
  }, {
    "p": [210, 67, -311],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [210, 67, -337],
    "s": [7, 6, 1],
    "c": 3616550,
    "t": 5
  }, {
    "p": [236, 71, -324],
    "s": [1, 5, 25],
    "pe": 1,
    "c": 3616550,
    "t": 5
  }, {
    "p": [195, 66, -236],
    "s": [34, 52, 9],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 65, -347],
    "s": [9, 69, 10],
    "c": 5919310,
    "t": 11
  }, {
    "p": [303, 65, -236],
    "s": [9, 63, 12],
    "c": 6246729,
    "t": 11,
    "bo": 1
  }, {
    "p": [304, 66, -256],
    "s": [5, 1, 19],
    "c": 8220776,
    "t": 11
  }, {
    "p": [220, 66, -235],
    "s": [19, 1, 10],
    "c": 8220776,
    "t": 11
  }, {
    "p": [175, 65, -305],
    "s": [7, 34, 5],
    "c": 7694689,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 65, -279],
    "s": [7, 34, 5],
    "c": 7234139,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 99, -302],
    "s": [7, 5, 11],
    "c": 7233881,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 66, -292],
    "s": [7, 1, 21],
    "c": 8220776,
    "t": 11
  }, {
    "p": [322, 51, -302],
    "s": [30, 71, 58],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [364, 66, -274],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [336, 66, -274],
    "s": [4, 65, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [308, 66, -274],
    "s": [4, 56, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [336, 92, -274],
    "s": [52, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [344, 64, -296],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [336, 130, -302],
    "s": [6, 6, 68],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [320, 127, -302],
    "s": [32, 2, 65],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 5855577,
    "t": 2
  }, {
    "p": [336, 118, -274],
    "s": [52, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [356, 64, -296],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [350, 84, -296],
    "s": [10, 2, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [336, 122, -302],
    "s": [58, 3, 58],
    "c": 6973550,
    "t": 10
  }, {
    "p": [336, 125, -302],
    "s": [45, 3, 58],
    "c": 6973550,
    "t": 10
  }, {
    "p": [336, 128, -302],
    "s": [28, 3, 58],
    "c": 6973550,
    "t": 10
  }, {
    "p": [336, 131, -302],
    "s": [15, 3, 58],
    "c": 6973550,
    "t": 10
  }, {
    "p": [319, 129, -302],
    "s": [32, 2, 65],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [354, 129, -302],
    "s": [32, 2, 65],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [353, 127, -302],
    "s": [32, 2, 65],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 5855577,
    "t": 2
  }, {
    "p": [336, 136, -302],
    "s": [6, 2, 68],
    "t": 5
  }, {
    "p": [185, 84, -65],
    "s": [2, 20, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [173, 84, -65],
    "s": [2, 20, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [179, 102, -65],
    "s": [10, 2, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [277, 51, -190],
    "s": [88, 63, 86],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [320, 51, -232],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 51, -110],
    "s": [106, 72, 80],
    "c": 8878432,
    "t": 10,
    "bo": 1
  }, {
    "p": [333, 66, -149],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [320, 51, -152],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [320, 51, -192],
    "s": [5, 77, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 51, -192],
    "s": [5, 77, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 51, -152],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 51, -232],
    "s": [4, 63, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [229, 66, -149],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [280, 66, 38],
    "s": [4, 65, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [229, 66, -71],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [333, 66, -110],
    "s": [5, 72, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [320, 88, -192],
    "s": [4, 4, 76],
    "c": 7895160,
    "t": 2
  }, {
    "p": [320, 110, -192],
    "s": [4, 4, 76],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 88, -192],
    "s": [4, 4, 76],
    "c": 7895160,
    "t": 2
  }, {
    "p": [234, 110, -192],
    "s": [4, 4, 76],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [301, 110, -232],
    "s": [34, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [301, 88, -232],
    "s": [34, 4, 4],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [277, 127, -192],
    "s": [102, 5, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [277, 119, -166],
    "s": [97, 2, 59],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [277, 121, -214],
    "s": [97, 2, 47],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [277, 114, -190],
    "s": [88, 3, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 117, -190],
    "s": [88, 3, 68],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 120, -190],
    "s": [88, 3, 50],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 123, -190],
    "s": [88, 3, 30],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 126, -190],
    "s": [88, 2, 16],
    "c": 6254184,
    "t": 10
  }, {
    "p": [277, 121, -165],
    "s": [97, 2, 59],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [277, 123, -215],
    "s": [97, 2, 47],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [277, 132, -192],
    "s": [102, 2, 5],
    "t": 5
  }, {
    "p": [333, 93, -110],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [333, 120, -110],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [11, 137, -444],
    "s": [100, 5, 5],
    "c": 7895160,
    "t": 2
  }, {
    "p": [11, 142, -444],
    "s": [100, 2, 5],
    "t": 5
  }, {
    "p": [10, 128, -416],
    "s": [97, 2, 61],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [10, 130, -416],
    "s": [97, 2, 62],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [43, 69, -400],
    "s": [13, 70, 7],
    "c": 6381921,
    "t": 11
  }, {
    "p": [229, 66, -110],
    "s": [5, 72, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [229, 93, -110],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2
  }, {
    "p": [229, 120, -110],
    "s": [4, 4, 74],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 120, -149],
    "s": [100, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 120, -71],
    "s": [100, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 93, -149],
    "s": [100, 4, 4],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [281, 137, -110],
    "s": [120, 5, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [281, 131, -132],
    "s": [113, 2, 50],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 6579300,
    "t": 2
  }, {
    "p": [281, 133, -133],
    "s": [113, 2, 50],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [281, 131, -89],
    "s": [113, 2, 50],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 6579300,
    "t": 2
  }, {
    "p": [281, 133, -88],
    "s": [113, 2, 50],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [281, 142, -110],
    "s": [120, 2, 5],
    "t": 5
  }, {
    "p": [281, 124, -110],
    "s": [106, 4, 80],
    "c": 8878432,
    "t": 10
  }, {
    "p": [281, 128, -110],
    "s": [106, 3, 60],
    "c": 8878432,
    "t": 10
  }, {
    "p": [281, 131, -110],
    "s": [106, 4, 43],
    "c": 8878432,
    "t": 10
  }, {
    "p": [281, 135, -110],
    "s": [106, 3, 21],
    "c": 8878432,
    "t": 10
  }, {
    "p": [263, 51, -43],
    "s": [60, 62, 72],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [263, 125, -40],
    "s": [71, 2, 70],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 6908265,
    "t": 2
  }, {
    "p": [262, 127, -40],
    "s": [71, 2, 70],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [281, 93, -71],
    "s": [100, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [292, 66, -68],
    "s": [4, 71, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [292, 66, -8],
    "s": [4, 71, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 66, -8],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 66, -68],
    "s": [4, 47, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [263, 109, -8],
    "s": [54, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [234, 109, -38],
    "s": [4, 4, 56],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [292, 109, -38],
    "s": [4, 4, 56],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [262, 113, -43],
    "s": [59, 4, 72],
    "c": 6973550,
    "t": 10
  }, {
    "p": [267, 117, -43],
    "s": [50, 4, 72],
    "c": 6973550,
    "t": 10
  }, {
    "p": [272, 121, -43],
    "s": [38, 4, 72],
    "c": 6973550,
    "t": 10
  }, {
    "p": [277, 125, -38],
    "s": [28, 4, 62],
    "c": 6973550,
    "t": 10
  }, {
    "p": [283, 129, -38],
    "s": [17, 4, 62],
    "c": 6973550,
    "t": 10
  }, {
    "p": [288, 133, -38],
    "s": [6, 3, 62],
    "c": 6973550,
    "t": 10
  }, {
    "p": [292, 113, -37],
    "s": [2, 23, 61],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [233, 84, -32],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [233, 84, -44],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [233, 102, -38],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [321, 66, -166],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [321, 66, -178],
    "s": [2, 20, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [321, 84, -172],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [411, 66, -212],
    "s": [90, 38, 138],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [413, 66, -6],
    "s": [90, 50, 88],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [208, 66, 90],
    "s": [140, 80, 88],
    "c": 8215901,
    "t": 10,
    "bo": 1
  }, {
    "p": [20, 66, 96],
    "s": [116, 53, 80],
    "c": 9342330,
    "t": 10,
    "bo": 1
  }, {
    "p": [425, 51, -96],
    "s": [90, 71, 92],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [334, 51, 80],
    "s": [110, 79, 86],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [-37, 51, 57],
    "s": [4, 69, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [20, 51, 57],
    "s": [4, 89, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [20, 91, 57],
    "s": [110, 4, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [20, 139, 96],
    "s": [5, 5, 92],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-11, 130, 96],
    "s": [65, 2, 88],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 4737096,
    "t": 2
  }, {
    "p": [51, 130, 96],
    "s": [65, 2, 88],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 4737096,
    "t": 2
  }, {
    "p": [20, 144, 96],
    "s": [5, 2, 92],
    "t": 5
  }, {
    "p": [-12, 132, 96],
    "s": [65, 2, 88],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [52, 132, 96],
    "s": [65, 2, 88],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [20, 116, 57],
    "s": [110, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [-37, 91, 96],
    "s": [4, 4, 74],
    "c": 7895160,
    "t": 2
  }, {
    "p": [-37, 116, 96],
    "s": [4, 4, 74],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [20, 119, 96],
    "s": [113, 6, 80],
    "c": 9342330,
    "t": 10,
    "bo": 1
  }, {
    "p": [20, 125, 96],
    "s": [91, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [20, 129, 96],
    "s": [69, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [20, 133, 96],
    "s": [46, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [20, 137, 96],
    "s": [25, 4, 80],
    "c": 9342330,
    "t": 10
  }, {
    "p": [-15, 66, 57],
    "s": [2, 21, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-3, 66, 57],
    "s": [2, 21, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [-9, 85, 57],
    "s": [10, 2, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [367, 66, -144],
    "s": [4, 38, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [367, 66, -212],
    "s": [5, 62, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [367, 100, -212],
    "s": [4, 4, 132],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [377, 100, -144],
    "s": [16, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [412, 127, -212],
    "s": [106, 5, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [412, 116, -248],
    "s": [98, 2, 75],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 4605510,
    "t": 2
  }, {
    "p": [412, 118, -249],
    "s": [98, 2, 75],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [412, 118, -174],
    "s": [98, 2, 77],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [412, 116, -175],
    "s": [98, 2, 77],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 4605510,
    "t": 2
  }, {
    "p": [412, 132, -212],
    "s": [106, 2, 5],
    "t": 5
  }, {
    "p": [411, 104, -212],
    "s": [90, 4, 138],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 108, -212],
    "s": [90, 4, 117],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 112, -212],
    "s": [90, 4, 94],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 116, -212],
    "s": [90, 4, 73],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 124, -212],
    "s": [90, 4, 29],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 120, -212],
    "s": [90, 4, 51],
    "c": 8215901,
    "t": 10
  }, {
    "p": [411, 128, -212],
    "s": [90, 1, 11],
    "c": 8215901,
    "t": 10
  }, {
    "p": [366, 66, -237],
    "s": [2, 20, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [366, 66, -249],
    "s": [2, 20, 2],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [366, 84, -243],
    "s": [2, 2, 10],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [381, 66, -141],
    "s": [4, 57, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [381, 66, -51],
    "s": [4, 57, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [381, 66, -96],
    "s": [5, 73, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [381, 119, -96],
    "s": [4, 4, 86],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [427, 119, -96],
    "s": [88, 4, 94],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [427, 138, -96],
    "s": [108, 6, 6],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [427, 131, -121],
    "s": [102, 2, 52],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 6052956,
    "t": 2
  }, {
    "p": [427, 131, -70],
    "s": [102, 2, 52],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 6052956,
    "t": 2
  }, {
    "p": [427, 133, -69],
    "s": [102, 2, 52],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [427, 133, -122],
    "s": [102, 2, 52],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [427, 144, -96],
    "s": [108, 2, 6],
    "t": 5
  }, {
    "p": [425, 123, -96],
    "s": [90, 5, 91],
    "c": 6973550,
    "t": 10
  }, {
    "p": [425, 128, -96],
    "s": [90, 4, 69],
    "c": 6973550,
    "t": 10
  }, {
    "p": [425, 132, -96],
    "s": [90, 4, 47],
    "c": 6973550,
    "t": 10
  }, {
    "p": [425, 136, -96],
    "s": [90, 4, 25],
    "c": 6973550,
    "t": 10
  }, {
    "p": [369, 66, -49],
    "s": [4, 51, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [369, 66, 35],
    "s": [4, 51, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [369, 66, -7],
    "s": [5, 65, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [369, 113, -7],
    "s": [4, 4, 80],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [376, 113, -49],
    "s": [10, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [333, 66, -71],
    "s": [4, 58, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [388, 66, 38],
    "s": [4, 65, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [334, 66, 38],
    "s": [4, 83, 5],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [334, 95, 38],
    "s": [104, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [334, 127, 38],
    "s": [104, 4, 4],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [280, 127, 49],
    "s": [4, 4, 18],
    "l": 1,
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [280, 95, 49],
    "s": [4, 4, 18],
    "c": 11513775,
    "t": 2
  }, {
    "p": [277, 66, 47],
    "s": [4, 81, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [139, 66, 47],
    "s": [4, 81, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 66, -12],
    "s": [92, 19, 145],
    "c": 6250335,
    "t": 11
  }, {
    "p": [64, 85, 28],
    "s": [2, 38, 59],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [64, 85, -43],
    "s": [2, 38, 53],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [150, 85, -27],
    "s": [2, 38, 77],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [150, 85, 34],
    "s": [2, 38, 19],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [208, 66, 47],
    "s": [4, 104, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [208, 112, 47],
    "s": [134, 4, 4],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [208, 143, 47],
    "s": [134, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [252, 66, 81],
    "s": [85, 17, 73],
    "c": 6250335
  }, {
    "p": [277, 143, 87],
    "s": [4, 4, 76],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [413, 130, -7],
    "s": [107, 5, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [413, 124, -29],
    "s": [99, 2, 51],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [413, 124, 16],
    "s": [99, 2, 54],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5066061,
    "t": 2
  }, {
    "p": [413, 126, 17],
    "s": [99, 2, 54],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [413, 126, -30],
    "s": [99, 2, 51],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [413, 135, -7],
    "s": [107, 2, 5],
    "t": 5
  }, {
    "p": [413, 117, -6],
    "s": [90, 3, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [413, 120, -6],
    "s": [90, 3, 71],
    "c": 8215901,
    "t": 10
  }, {
    "p": [413, 123, -6],
    "s": [90, 3, 58],
    "c": 8215901,
    "t": 10
  }, {
    "p": [413, 126, -6],
    "s": [90, 3, 37],
    "c": 8215901,
    "t": 10
  }, {
    "p": [413, 129, -6],
    "s": [90, 3, 22],
    "c": 8215901,
    "t": 10
  }, {
    "p": [334, 149, 80],
    "s": [5, 5, 106],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [364, 140, 80],
    "s": [61, 2, 97],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 7039851,
    "t": 2
  }, {
    "p": [303, 140, 80],
    "s": [61, 2, 97],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 7039851,
    "t": 2
  }, {
    "p": [334, 154, 80],
    "s": [5, 2, 106],
    "t": 5
  }, {
    "p": [304, 143, 80],
    "s": [63, 2, 97],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [364, 142, 80],
    "s": [63, 2, 97],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [334, 130, 80],
    "s": [110, 5, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [334, 135, 80],
    "s": [89, 4, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [334, 139, 80],
    "s": [67, 4, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [334, 143, 80],
    "s": [45, 4, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [334, 147, 80],
    "s": [23, 4, 86],
    "c": 6254184,
    "t": 10
  }, {
    "p": [208, 169, 90],
    "s": [6, 6, 104],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [246, 158, 90],
    "s": [81, 2, 97],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 4605510,
    "t": 2
  }, {
    "p": [170, 159, 90],
    "s": [81, 2, 97],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 4605510,
    "t": 2
  }, {
    "p": [169, 161, 90],
    "s": [81, 2, 97],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [247, 160, 90],
    "s": [81, 2, 97],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [208, 175, 90],
    "s": [6, 2, 104],
    "t": 5
  }, {
    "p": [208, 147, 90],
    "s": [140, 3, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 150, 90],
    "s": [124, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 154, 90],
    "s": [102, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 158, 90],
    "s": [81, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 162, 90],
    "s": [58, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 166, 90],
    "s": [36, 4, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [208, 170, 90],
    "s": [15, 3, 88],
    "c": 8215901,
    "t": 10
  }, {
    "p": [-72, 87, -45],
    "s": [4, 4, 48],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-101, 110, 5],
    "s": [62, 4, 44],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [368, 84, -22],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [368, 84, -34],
    "s": [2, 22, 2],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [368, 104, -28],
    "s": [2, 2, 10],
    "c": 11513775,
    "t": 2,
    "bo": 1
  }, {
    "p": [179, 84, 47],
    "s": [2, 21, 4],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [167, 84, 47],
    "s": [2, 21, 4],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [173, 103, 47],
    "s": [10, 2, 4],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [107, 146, -9],
    "s": [101, 5, 5],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 134, 26],
    "s": [93, 2, 74],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 4868682,
    "t": 2
  }, {
    "p": [150, 66, -64],
    "s": [4, 58, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [151, 66, -9],
    "s": [3, 81, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [150, 66, 44],
    "s": [4, 58, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 85, 50],
    "s": [84, 38, 19],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [107, 85, -44],
    "s": [84, 38, 51],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [64, 66, -2],
    "s": [5, 54, 2],
    "pe": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 66, -16],
    "s": [5, 54, 2],
    "pe": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 105, -9],
    "s": [5, 2, 12],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [150, 66, 11],
    "s": [4, 54, 2],
    "pe": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [150, 66, 25],
    "s": [4, 54, 2],
    "pe": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [150, 105, 18],
    "s": [4, 2, 12],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [150, 106, 18],
    "s": [2, 15, 13],
    "pe": 1,
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [64, 107, -9],
    "s": [2, 16, 15],
    "pe": 1,
    "c": 6254184,
    "t": 10
  }, {
    "p": [63, 123, -9],
    "s": [2, 24, 4],
    "c": 7895160,
    "t": 2
  }, {
    "p": [64, 85, -68],
    "s": [5, 39, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 85, 54],
    "s": [5, 39, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 120, -9],
    "s": [5, 4, 114],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [64, 120, 50],
    "s": [5, 4, 4],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 135, -41],
    "s": [93, 2, 70],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 4868682,
    "t": 2
  }, {
    "p": [150, 120, -10],
    "s": [4, 4, 104],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [107, 115, 10],
    "s": [85, 1, 71],
    "c": 6250335,
    "t": 2
  }, {
    "p": [107, 124, -9],
    "s": [88, 4, 122],
    "c": 6254184,
    "t": 10,
    "bo": 1
  }, {
    "p": [107, 136, 27],
    "s": [93, 2, 74],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [107, 151, -9],
    "s": [101, 2, 5],
    "l": 1,
    "t": 5
  }, {
    "p": [107, 137, -42],
    "s": [93, 2, 70],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [107, 128, -9],
    "s": [88, 4, 104],
    "c": 6254184,
    "t": 10
  }, {
    "p": [107, 132, -9],
    "s": [88, 4, 82],
    "c": 6254184,
    "t": 10
  }, {
    "p": [107, 136, -9],
    "s": [88, 4, 60],
    "c": 6254184,
    "t": 10
  }, {
    "p": [107, 140, -9],
    "s": [88, 4, 38],
    "c": 6254184,
    "t": 10
  }, {
    "p": [107, 144, -9],
    "s": [88, 3, 16],
    "c": 6254184,
    "t": 10
  }, {
    "p": [50, 83, -9],
    "s": [22, 2, 88],
    "c": 7895160,
    "t": 2
  }, {
    "p": [41, 66, -51],
    "s": [2, 20, 2],
    "c": 7895160,
    "t": 2
  }, {
    "p": [41, 66, 33],
    "s": [2, 20, 2],
    "c": 7895160,
    "t": 2
  }, {
    "p": [92, 66, 40],
    "s": [2, 39, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [80, 66, 40],
    "s": [2, 39, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [121, 66, -18],
    "s": [2, 39, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [133, 66, -18],
    "s": [2, 39, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [127, 105, -18],
    "s": [14, 2, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [86, 105, 40],
    "s": [14, 2, 2],
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [10, 128, -471],
    "s": [97, 2, 59],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [10, 130, -472],
    "s": [97, 2, 59],
    "l": 1,
    "r": [-0.35, 0, 0],
    "t": 5
  }, {
    "p": [10, 51, -444],
    "s": [92, 67, 107],
    "c": 6254184,
    "t": 10
  }, {
    "p": [10, 118, -444],
    "s": [92, 2, 107],
    "c": 6254184,
    "t": 10
  }, {
    "p": [10, 123, -444],
    "s": [92, 5, 75],
    "c": 6254184,
    "t": 10
  }, {
    "p": [10, 128, -444],
    "s": [92, 5, 49],
    "c": 6254184,
    "t": 10
  }, {
    "p": [10, 133, -444],
    "s": [92, 5, 22],
    "c": 6254184,
    "t": 10
  }, {
    "p": [55, 114, -444],
    "s": [4, 4, 107],
    "c": 11513775,
    "t": 2
  }, {
    "p": [71, 51, -393],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [207, 51, -393],
    "s": [4, 64, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [116, 51, -393],
    "s": [4, 77, 5],
    "c": 11513775,
    "t": 2
  }, {
    "p": [71, 51, -445],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [71, 51, -495],
    "s": [4, 62, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [139, 111, -393],
    "s": [132, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [71, 110, -444],
    "s": [4, 4, 98],
    "l": 1,
    "c": 11513775,
    "t": 2
  }, {
    "p": [139, 134, -443],
    "s": [7, 7, 121],
    "c": 11513775,
    "t": 2
  }, {
    "p": [101, 121, -443],
    "s": [79, 3, 113],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 4605510,
    "t": 2
  }, {
    "p": [100, 124, -443],
    "s": [79, 2, 113],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [139, 141, -443],
    "s": [7, 2, 121],
    "l": 1,
    "t": 5
  }, {
    "p": [178, 124, -443],
    "s": [78, 3, 113],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [139, 66, -444],
    "s": [136, 49, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [139, 115, -444],
    "s": [107, 5, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [139, 120, -444],
    "s": [83, 5, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [139, 125, -444],
    "s": [55, 5, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [139, 130, -444],
    "s": [28, 4, 104],
    "c": 9342330,
    "t": 10
  }, {
    "p": [161, 51, -393],
    "s": [4, 77, 5],
    "c": 11513775,
    "t": 2
  }, {
    "p": [214, 113, -385],
    "s": [48, 2, 70],
    "l": 1,
    "r": [0, 0, 0.52],
    "c": 6908265,
    "t": 2
  }, {
    "p": [213, 115, -385],
    "s": [48, 2, 70],
    "l": 1,
    "r": [0, 0, 0.52],
    "t": 5
  }, {
    "p": [233, 125, -386],
    "s": [5, 5, 71],
    "c": 11513775,
    "t": 2
  }, {
    "p": [233, 130, -386],
    "s": [5, 2, 71],
    "t": 5
  }, {
    "p": [55, 65, 13],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [55, 65, -64],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-65, 65, -64],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-65, 65, -52],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-72, 110, -45],
    "s": [4, 4, 48],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [-130, 87, -44],
    "s": [4, 4, 46],
    "c": 7500402,
    "t": 2
  }, {
    "p": [-130, 110, -44],
    "s": [4, 4, 46],
    "c": 7500402,
    "t": 2,
    "bo": 1
  }, {
    "p": [28, 65, -95],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-88, 65, 36],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [28, 65, 50],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [28, 77, 50],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [146, 85, 35],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [60, 85, -36],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [60, 85, -28],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-17, 65, -178],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-56, 65, -128],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-164, 52, -158],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-152, 52, -158],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 52, -86],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 52, -74],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 52, 18],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 52, 6],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-315, 64, 18],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-231, 52, -93],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-281, 52, -49],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-269, 52, -49],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-128, 52, -266],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-116, 52, -304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-116, 64, -304],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-162, 65, -28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-19, 65, -28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [216, 83, 40],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [157, 83, -56],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [300, 83, -50],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [300, 83, -62],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [361, 83, 31],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [360, 65, -198],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [45, 65, -66],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-55, 65, -66],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-68, 65, 22],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-68, 65, 14],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-163, 65, 54],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-165, 65, -38],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-269, 52, -59],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-317, 52, -64],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-317, 52, -56],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-317, 52, -173],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-305, 52, 20],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-184, 52, -204],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-184, 52, -196],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [75, 71, -311],
    "s": [31, 3, 7],
    "c": 8220776
  }, {
    "p": [94, 66, -292],
    "s": [6, 7, 44],
    "c": 10983566,
    "t": 11
  }, {
    "p": [56, 66, -292],
    "s": [6, 7, 44],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 66, -273],
    "s": [32, 7, 6],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 66, -311],
    "s": [32, 7, 6],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 71, -273],
    "s": [31, 3, 7],
    "c": 8220776
  }, {
    "p": [56, 71, -292],
    "s": [7, 3, 45],
    "c": 8220776,
    "t": 11
  }, {
    "p": [94, 71, -292],
    "s": [7, 3, 45],
    "c": 8220776
  }, {
    "p": [75, 66, -292],
    "s": [32, 1, 33],
    "c": 10983566
  }, {
    "p": [75, 66, -292],
    "s": [9, 23, 9],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 77, -292],
    "s": [20, 3, 20],
    "c": 8220776,
    "t": 11
  }, {
    "p": [75, 86, -292],
    "s": [14, 3, 14],
    "c": 8220776,
    "t": 11
  }, {
    "p": [75, 74, -311],
    "s": [31, 1, 7],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 74, -273],
    "s": [31, 1, 7],
    "l": 1,
    "t": 5
  }, {
    "p": [94, 74, -292],
    "s": [7, 1, 45],
    "l": 1,
    "t": 5
  }, {
    "p": [56, 74, -292],
    "s": [7, 1, 45],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 80, -292],
    "s": [20, 1, 20],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 89, -292],
    "s": [14, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 67, -292],
    "s": [32, 2, 33],
    "c": 9165268,
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [63, 62, -565],
    "s": [173, 63, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [351, 83, 34],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [296, 83, -25],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [296, 83, -17],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [375, 65, -139],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [325, 65, -202],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [325, 65, -210],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [206, 65, -227],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [206, 65, -220],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-222, 52, -295],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-17, 65, -190],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [157, 65, -201],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [157, 65, -213],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-1, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [11, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [23, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-1, 77, -363],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [77, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [89, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [135, 65, -362],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [135, 77, -363],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [104, 65, -301],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [65, 65, -218],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-11, 66, -365],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [145, 65, -365],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [152, 65, -365],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [102, 65, -291],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [147, 65, -198],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [55, 65, -215],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-67, 65, -9],
    "s": [1, 18, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": 7895160,
    "t": 2
  }, {
    "p": [-31, 65, -28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-31, 65, -16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [39, 66, -35],
    "s": [1, 19, 5],
    "pe": 1,
    "v": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [39, 66, -35],
    "s": [1, 19, 3],
    "i": 3,
    "t": 2,
    "d": 2
  }, {
    "p": [-161, 87, -309],
    "s": [4, 8, 10],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [381, 91, -96],
    "s": [4, 4, 86],
    "c": 11513775,
    "t": 2
  }, {
    "p": [202, 82, -11],
    "s": [110, 2, 165],
    "l": 1,
    "t": 5
  }, {
    "p": [177, 121, -443],
    "s": [79, 3, 113],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 4605510,
    "t": 2
  }, {
    "p": [383, 65, 26],
    "s": [12, 70, 6],
    "c": 11293523
  }, {
    "p": [63, 121, -502],
    "s": [174, 4, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [-22, 96, -502],
    "s": [4, 34, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [63, 156, -568],
    "s": [6, 6, 145],
    "c": 6381921,
    "t": 2
  }, {
    "p": [18, 140, -568],
    "s": [97, 3, 138],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": 6381921,
    "t": 2
  }, {
    "p": [108, 140, -568],
    "s": [102, 3, 138],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": 6381921,
    "t": 2
  }, {
    "p": [63, 162, -568],
    "s": [6, 2, 145],
    "t": 5
  }, {
    "p": [109, 143, -568],
    "s": [102, 2, 138],
    "l": 1,
    "r": [0, 0, -0.35],
    "t": 5
  }, {
    "p": [17, 143, -568],
    "s": [97, 2, 138],
    "l": 1,
    "r": [0, 0, 0.35],
    "t": 5
  }, {
    "p": [93, 96, -502],
    "s": [4, 50, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [63, 125, -565],
    "s": [173, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 133, -565],
    "s": [131, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 129, -565],
    "s": [153, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 137, -565],
    "s": [109, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 141, -565],
    "s": [86, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 145, -565],
    "s": [65, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 149, -565],
    "s": [43, 4, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [63, 153, -565],
    "s": [22, 3, 128],
    "c": 8217957,
    "t": 10
  }, {
    "p": [-108, 107, -447],
    "s": [97, 2, 59],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": 5395026,
    "t": 2
  }, {
    "p": [-108, 108, -446],
    "s": [97, 2, 59],
    "l": 1,
    "r": [0.35, 0, 0],
    "t": 5
  }, {
    "p": [-108, 116, -475],
    "s": [100, 5, 5],
    "c": 7895160,
    "t": 2
  }, {
    "p": [-108, 121, -475],
    "s": [100, 2, 5],
    "t": 5
  }, {
    "p": [10, 114, -392],
    "s": [94, 4, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [55, 51, -392],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [-35, 51, -392],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [11, 51, -392],
    "s": [4, 63, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [30, 96, -502],
    "s": [4, 52, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [63, 109, -502],
    "s": [174, 4, 4],
    "c": 6381921,
    "t": 2
  }, {
    "p": [10, 120, -444],
    "s": [92, 3, 102],
    "c": 6254184,
    "t": 10
  }, {
    "p": [55, 51, -444],
    "s": [4, 86, 4],
    "c": 11513775,
    "t": 2
  }, {
    "p": [296, 66, -292],
    "s": [9, 19, 34],
    "c": 7891810,
    "t": 11
  }, {
    "p": [298, 101, -292],
    "s": [3, 9, 12],
    "c": 6051153,
    "t": 11,
    "bo": 1
  }, {
    "p": [298, 85, -301],
    "s": [4, 22, 6],
    "c": 6051153,
    "t": 11,
    "bo": 1
  }, {
    "p": [298, 85, -283],
    "s": [4, 23, 6],
    "c": 6051153,
    "t": 11,
    "bo": 1
  }, {
    "p": [300, 85, -292],
    "s": [1, 22, 23],
    "c": 5590860,
    "t": 11
  }, {
    "p": [293, 85, -297],
    "s": [1, 3, 1],
    "l": 1,
    "c": 9997922,
    "t": 5
  }, {
    "p": [294, 85, -301],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, -0.35, 0],
    "c": 9997922,
    "t": 5
  }, {
    "p": [293, 85, -306],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": 9997922,
    "t": 5
  }, {
    "p": [294, 85, -286],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, -0.17, 0],
    "c": 9997922,
    "t": 5
  }, {
    "p": [293, 85, -283],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, 1.05, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [294, 85, -278],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [-224, 53, -74],
    "s": [216, 0, 229],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [-277, 51, -77],
    "s": [104, 2, 202],
    "v": 1,
    "t": 5
  }, {
    "p": [-139, 51, -111],
    "s": [172, 2, 130],
    "v": 1,
    "t": 5
  }, {
    "p": [-211, 51, -183],
    "s": [12, 2, 14],
    "v": 1,
    "t": 5
  }, {
    "p": [-201, 51, -179],
    "s": [8, 2, 6],
    "v": 1,
    "t": 5
  }, {
    "p": [-183, 51, -182],
    "s": [8, 2, 12],
    "v": 1,
    "t": 5
  }, {
    "p": [22, 66, -48],
    "s": [210, 0, 258],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [-1, 64, 0],
    "s": [140, 2, 142],
    "v": 1,
    "t": 5
  }, {
    "p": [-100, 64, 50],
    "s": [58, 2, 42],
    "v": 1,
    "t": 5
  }, {
    "p": [-149, 53, 8],
    "s": [40, 13, 126],
    "v": 1,
    "t": 5
  }, {
    "p": [-54, 51, -143],
    "s": [58, 15, 42],
    "v": 1,
    "t": 5
  }, {
    "p": [5, 64, -123],
    "s": [60, 2, 104],
    "v": 1,
    "t": 5
  }, {
    "p": [-124, 51, -285],
    "s": [203, 2, 50],
    "v": 1,
    "t": 5
  }, {
    "p": [343, 64, -262],
    "s": [77, 2, 72],
    "v": 1,
    "t": 5
  }, {
    "p": [343, 64, -122],
    "s": [82, 2, 217],
    "v": 1,
    "t": 5
  }, {
    "p": [327, 64, -11],
    "s": [140, 20, 129],
    "v": 1,
    "t": 5
  }, {
    "p": [202, 82, -11],
    "s": [110, 2, 165],
    "v": 1,
    "t": 5
  }, {
    "p": [213, 64, -112],
    "s": [39, 20, 37],
    "v": 1,
    "t": 5
  }, {
    "p": [213, 64, -207],
    "s": [40, 2, 63],
    "v": 1,
    "t": 5
  }, {
    "p": [-131, 66, 50],
    "s": [119, 0, 210],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [74, 66, -271],
    "s": [214, 0, 223],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [80, 51, -272],
    "s": [226, 15, 194],
    "v": 1,
    "t": 5
  }, {
    "p": [80, 51, -272],
    "s": [226, 15, 194],
    "l": 1,
    "t": 5
  }, {
    "p": [-185, 51, -254],
    "s": [8, 2, 12],
    "v": 1,
    "t": 5
  }, {
    "p": [-195, 51, -257],
    "s": [12, 2, 6],
    "v": 1,
    "t": 5
  }, {
    "p": [-216, 51, -254],
    "s": [19, 2, 12],
    "v": 1,
    "t": 5
  }, {
    "p": [-195, 53, -304],
    "s": [201, 0, 97],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [-65, 53, -289],
    "s": [64, 13, 195],
    "i": 9,
    "t": 5
  }, {
    "p": [-149, 53, -78],
    "s": [145, 13, 46],
    "i": 9,
    "t": 5,
    "d": 1
  }, {
    "p": [-101, 53, -140],
    "s": [36, 13, 182],
    "i": 9,
    "t": 5
  }, {
    "p": [216, 66, -157],
    "s": [197, 18, 53],
    "i": 9,
    "t": 5,
    "d": 1
  }, {
    "p": [357, 66, -103],
    "s": [244, 18, 55],
    "i": 9,
    "t": 5,
    "d": 1
  }, {
    "p": [344, 66, -246],
    "s": [82, 0, 234],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [220, 66, -208],
    "s": [88, 0, 52],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [342, 84, 36],
    "s": [170, 0, 223],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [208, 84, -10],
    "s": [131, 0, 240],
    "i": 4,
    "l": 1,
    "en": 1.8,
    "t": 5
  }, {
    "p": [-72, 52, -212],
    "s": [98, 50, 108],
    "c": 8548950,
    "t": 10,
    "bo": 1
  }, {
    "p": [65, 77, -218],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [157, 77, -207],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [83, 77, -363],
    "s": [24, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [17, 77, -363],
    "s": [24, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [-1, 89, -363],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [135, 89, -363],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [104, 77, -301],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-17, 77, -184],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [28, 77, -95],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [55, 77, -64],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-31, 77, -22],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [-19, 77, -28],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-65, 77, -58],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [28, 89, 50],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-88, 77, 36],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-162, 77, -28],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-158, 64, -158],
    "s": [24, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-275, 64, -49],
    "s": [24, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-315, 64, 6],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-315, 64, -80],
    "s": [12, 1, 24],
    "l": 1,
    "t": 5
  }, {
    "p": [-315, 76, 18],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-231, 64, -93],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-128, 64, -266],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-116, 76, -304],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [216, 95, 40],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [157, 95, -56],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [361, 95, 31],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [300, 95, -50],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [360, 77, -198],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-56, 77, -128],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [-282, 105, 25],
    "s": [88, 4, 4],
    "c": 8224125,
    "t": 2,
    "bo": 1
  }, {
    "p": [-282, 53, 25],
    "s": [5, 57, 5],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-236, 53, 25],
    "s": [4, 56, 4],
    "c": 8553090,
    "t": 2,
    "bo": 1
  }, {
    "p": [-328, 53, 25],
    "s": [4, 56, 4],
    "c": 9013641,
    "t": 2,
    "bo": 1
  }, {
    "p": [-234, 91, 14],
    "s": [2, 4, 64],
    "c": 7500402,
    "t": 2
  }, {
    "p": [76, 114, -188],
    "s": [84, 6, 43],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 114, -94],
    "s": [84, 6, 43],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 120, -101],
    "s": [84, 5, 29],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 125, -108],
    "s": [84, 3, 16],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 128, -112],
    "s": [84, 3, 7],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 120, -181],
    "s": [84, 5, 29],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 125, -175],
    "s": [84, 3, 16],
    "c": 8878432,
    "t": 10
  }, {
    "p": [76, 128, -170],
    "s": [84, 3, 7],
    "c": 8878432,
    "t": 10
  }, {
    "p": [-270, 51, -177],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-258, 51, 24],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-225, 51, -42],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-160, 64, -3],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [-133, 65, 71],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [34, 63, -141],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-25, 64, -96],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [-9, 65, 56],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [56, 85, -2],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [157, 85, 11],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [173, 83, 46],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [86, 85, 40],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [179, 82, -65],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [233, 82, -38],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [368, 84, -28],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [96, 64, -212],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-105, 52, -266],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-142, 51, -310],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-180, 51, -301],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-225, 51, -277],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [366, 64, -243],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [350, 64, -296],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [321, 64, -172],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [3.14, 0, 3.14]
  }, {
    "p": [-72, 104, -212],
    "s": [99, 8, 108],
    "c": 8548950,
    "t": 10
  }, {
    "p": [-72, 112, -212],
    "s": [65, 6, 108],
    "c": 8548950,
    "t": 10
  }, {
    "p": [-72, 118, -212],
    "s": [35, 6, 108],
    "c": 8548950,
    "t": 10
  }, {
    "p": [127, 85, -18],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-259, 85, 23],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-305, 85, 23],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-235, 70, 4],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-226, 84, -44],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-226, 84, -81],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-271, 83, -176],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-308, 83, -176],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-228, 96, -164],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-145, 96, -164],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-197, 84, -103],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-102, 97, -123],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-130, 97, -96],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-132, 92, 4],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-159, 99, 14],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-22, 83, -185],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-24, 98, -97],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-224, 84, -278],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-187, 96, -260],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-76, 87, -309],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-49, 83, -267],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [140, 88, -194],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [56, 92, -213],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [33, 92, -188],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [33, 92, -93],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [-73, 76, 70],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-70, 92, 5],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [42, 97, 55],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [242, 121, 45],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [227, 100, -90],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [232, 92, -211],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [-3.14, 0, -3.14]
  }, {
    "p": [200, 88, -161],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [308, 105, 36],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [322, 98, -272],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [367, 92, 13],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [3.14, 0, 3.14]
  }, {
    "p": [294, 116, -25],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [335, 100, -92],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [322, 92, -212],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [379, 99, -118],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [3.14, 0, 3.14]
  }, {
    "p": [365, 78, -179],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [3.14, 0, 3.14]
  }, {
    "p": [175, 99, -281],
    "s": [7, 5, 9],
    "c": 6247502,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 103, -312],
    "s": [6, 10, 17],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [166, 65, -337],
    "s": [7, 3, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [165, 65, -348],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [175, 107, -246],
    "s": [6, 5, 12],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [175, 107, -265],
    "s": [6, 3, 14],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [175, 120, -244],
    "s": [9, 5, 4],
    "c": 6248017,
    "t": 11,
    "bo": 1
  }, {
    "p": [165, 65, -237],
    "s": [7, 3, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [183, 65, -300],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [167, 65, -280],
    "s": [5, 2, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [48, 64, -271],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [102, 64, -277],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [229, 64, -224],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [267, 129, -347],
    "s": [22, 3, 10],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [214, 105, -236],
    "s": [4, 5, 9],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [287, 115, -236],
    "s": [23, 5, 12],
    "c": 5918536,
    "t": 11,
    "bo": 1
  }, {
    "p": [237, 115, -236],
    "s": [30, 4, 9],
    "c": 7563360,
    "t": 11,
    "bo": 1
  }, {
    "p": [64, 64, -364],
    "s": [6, 3, 3],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [-20, 64, -328],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [175, 120, -355],
    "s": [9, 5, 6],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [176, 77, -363],
    "s": [5, 31, 22],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [130, 77, -371],
    "s": [90, 31, 4],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [68, 77, -371],
    "s": [34, 24, 4],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [12, 77, -371],
    "s": [78, 27, 4],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [-28, 77, -345],
    "s": [5, 29, 58],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [-44, 77, -315],
    "s": [27, 29, 4],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [-28, 106, -327],
    "s": [5, 3, 14],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [-28, 106, -363],
    "s": [5, 2, 22],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [-36, 106, -315],
    "s": [15, 3, 4],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [69, 101, -371],
    "s": [16, 3, 4],
    "l": 1,
    "c": 10983566,
    "t": 11
  }, {
    "p": [177, 65, -359],
    "s": [9, 12, 24],
    "c": 6575952,
    "t": 11
  }, {
    "p": [64, 65, -372],
    "s": [220, 12, 8],
    "c": 6379602,
    "t": 11
  }, {
    "p": [-43, 51, -341],
    "s": [37, 26, 58],
    "c": 6576209,
    "t": 11
  }, {
    "p": [-29, 77, -317],
    "s": [9, 37, 10],
    "c": 6247759,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 110, -335],
    "s": [6, 4, 23],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [291, 74, -313],
    "s": [7, 3, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [294, 65, -246],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [303, 110, -270],
    "s": [6, 4, 24],
    "c": 6708310,
    "t": 11,
    "bo": 1
  }, {
    "p": [182, 65, -263],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [294, 65, -335],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [270, 65, -339],
    "s": [8, 3, 4],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [303, 123, -340],
    "s": [9, 6, 4],
    "c": 8220776,
    "t": 11,
    "bo": 1
  }, {
    "p": [227, 95, -236],
    "s": [2, 5, 9],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 95, -249],
    "s": [6, 5, 2],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [303, 101, -263],
    "s": [6, 4, 2],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [97, 104, -219],
    "s": [2, 2, 15],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [97, 95, -219],
    "s": [1, 8, 13],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [97, 103, -224],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [97, 103, -216],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [112, 64, -218],
    "s": [4, 3, 7],
    "l": 1,
    "c": 4275000,
    "t": 5
  }, {
    "p": [-96, 98, -272],
    "s": [2, 2, 18],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [-96, 89, -274],
    "s": [1, 8, 13],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [-96, 97, -278],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-96, 97, -270],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-8, 107, 52],
    "s": [2, 2, 17],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [-8, 100, 49],
    "s": [1, 6, 9],
    "l": 1,
    "c": 7895160,
    "t": 2
  }, {
    "p": [-8, 106, 46],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-8, 106, 52],
    "s": [1, 1, 1],
    "l": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-213, 50, -197],
    "s": [4, 3, 7],
    "l": 1,
    "c": 3092271,
    "t": 5
  }, {
    "p": [-185, 50, -237],
    "s": [4, 3, 7],
    "l": 1,
    "c": 3092271,
    "t": 5
  }, {
    "p": [-199, 81, -260],
    "s": [33, 3, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-181, 53, -260],
    "s": [3, 31, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [-217, 53, -260],
    "s": [3, 31, 3],
    "c": 8684676,
    "t": 2,
    "bo": 1
  }, {
    "p": [130, 108, -371],
    "s": [90, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [12, 104, -371],
    "s": [78, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [69, 104, -371],
    "s": [16, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 125, -355],
    "s": [9, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-28, 106, -343],
    "s": [5, 1, 18],
    "l": 1,
    "t": 5
  }, {
    "p": [-28, 108, -363],
    "s": [5, 1, 22],
    "l": 1,
    "t": 5
  }, {
    "p": [-28, 109, -327],
    "s": [5, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [-38, 109, -315],
    "s": [11, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [-50, 106, -315],
    "s": [13, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [176, 108, -361],
    "s": [5, 1, 25],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 125, -329],
    "s": [9, 1, 26],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 133, -347],
    "s": [9, 1, 10],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 113, -312],
    "s": [6, 1, 17],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 110, -265],
    "s": [6, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 112, -245],
    "s": [6, 1, 14],
    "l": 1,
    "t": 5
  }, {
    "p": [303, 114, -267],
    "s": [6, 1, 18],
    "l": 1,
    "t": 5
  }, {
    "p": [303, 128, -236],
    "s": [9, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [199, 124, -236],
    "s": [39, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [175, 132, -236],
    "s": [9, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [303, 134, -347],
    "s": [9, 1, 10],
    "l": 1,
    "t": 5
  }, {
    "p": [292, 129, -347],
    "s": [13, 1, 10],
    "l": 1,
    "t": 5
  }, {
    "p": [211, 129, -347],
    "s": [63, 1, 10],
    "l": 1,
    "t": 5
  }, {
    "p": [300, 110, -292],
    "s": [7, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [300, 107, -301],
    "s": [8, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [157, 85, 11],
    "s": [10, 20, 1],
    "pe": 1,
    "v": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [56, 85, -2],
    "s": [10, 20, 1],
    "pe": 1,
    "v": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [303, 114, -333],
    "s": [6, 1, 19],
    "l": 1,
    "t": 5
  }, {
    "p": [303, 129, -340],
    "s": [9, 1, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [300, 95, -62],
    "s": [12, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [296, 90, -25],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [296, 90, -17],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [351, 90, 34],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [375, 72, -139],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [325, 72, -210],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [325, 72, -202],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [102, 72, -291],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [147, 72, -198],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [152, 72, -365],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [145, 72, -365],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [45, 72, -66],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-55, 72, -66],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-68, 72, 14],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-68, 72, 22],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-163, 72, 54],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-165, 72, -38],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-317, 59, -173],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-317, 59, -56],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-317, 59, -64],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-305, 59, 20],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-269, 59, -59],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-222, 59, -295],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [206, 72, -227],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [206, 72, -220],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [-205, 51, -258],
    "s": [3, 2, 4],
    "l": 1,
    "t": 5
  }, {
    "p": [-189, 51, -180],
    "s": [4, 2, 8],
    "l": 1,
    "t": 5
  }, {
    "p": [-189, 51, -180],
    "s": [4, 2, 8],
    "v": 1,
    "t": 5
  }, {
    "p": [61, 89, -2],
    "s": [1, 2, 1],
    "pe": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [61, 99, -2],
    "s": [1, 2, 1],
    "pe": 1,
    "c": 7895160,
    "t": 5
  }, {
    "p": [-8, 109, 52],
    "s": [2, 1, 17],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-96, 100, -272],
    "s": [2, 1, 18],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [97, 106, -219],
    "s": [2, 1, 15],
    "l": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-234, 95, 14],
    "s": [3, 25, 64],
    "v": 1,
    "c": 7500402,
    "t": 2
  }, {
    "p": [55, 72, -215],
    "s": [6, 1, 6],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 90, -292],
    "s": [3, 16, 3],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 99, -292],
    "s": [2, 3, 12],
    "c": 10983566,
    "t": 11
  }, {
    "p": [75, 102, -292],
    "s": [2, 1, 12],
    "l": 1,
    "t": 5
  }, {
    "p": [75, 106, -292],
    "s": [3, 1, 3],
    "l": 1,
    "t": 5
  }, {
    "p": [-276, 53, -16],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [245, 67, -293],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-8, 100, 50],
    "s": [2, 16, 13],
    "v": 1,
    "c": 7895160,
    "t": 2,
    "bo": 1
  }, {
    "p": [238, 66, -292],
    "s": [114, 50, 95],
    "i": 14,
    "l": 1
  }, {
    "p": [-273, 53, -22],
    "s": [91, 50, 86],
    "i": 14,
    "l": 1
  }, {
    "p": [74, 66, -292],
    "s": [91, 50, 86],
    "i": 14,
    "l": 1
  }, {
    "p": [192, 84, -9],
    "s": [73, 50, 103],
    "i": 14,
    "l": 1
  }, {
    "p": [-199, 83, -212],
    "s": [36, 8, 96],
    "c": 8355711,
    "t": 11,
    "bo": 1
  }, {
    "p": [-329, 87, 65],
    "s": [62, 1, 13],
    "i": 30,
    "r": [1.57, 0, 1.57],
    "st": "Map By  CrispyCrust",
    "sc": "#ffffff",
    "bv": 1,
    "sf": 70
  }, {
    "p": [175, 86, -259],
    "s": [6, 21, 35],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 71, -273],
    "s": [6, 15, 7],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [175, 71, -247],
    "s": [6, 15, 10],
    "c": 10983566,
    "t": 11,
    "bo": 1
  }, {
    "p": [351, 93, -302],
    "s": [28, 28, 58],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [365, 51, -302],
    "s": [4, 45, 58],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [350, 51, -297],
    "s": [30, 48, 2],
    "c": 6973550,
    "t": 10,
    "bo": 1
  }, {
    "p": [172, 70, -253],
    "s": [1, 17, 4],
    "pe": 1,
    "c": 3616550,
    "t": 5
  }, {
    "p": [172, 70, -257],
    "s": [1, 19, 4],
    "pe": 1,
    "c": "#483b2d",
    "t": 5
  }, {
    "p": [172, 69, -261],
    "s": [1, 18, 4],
    "pe": 1,
    "c": "#574837",
    "t": 5
  }, {
    "p": [172, 69, -265],
    "s": [1, 19, 4],
    "pe": 1,
    "c": "#483b2d",
    "t": 5
  }, {
    "p": [172, 70, -269],
    "s": [1, 17, 4],
    "pe": 1,
    "c": 3616550,
    "t": 5
  }, {
    "p": [163, 65, -248],
    "s": [4, 2, 14],
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#5a4938",
    "t": 5
  }, {
    "p": [165, 65, -327],
    "s": [4, 2, 14],
    "l": 1,
    "r": [3.14, -0.52, 3.14],
    "c": "#5a4938",
    "t": 5
  }, {
    "p": [293, 88, -306],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5,
    "ab": 1
  }, {
    "p": [294, 87, -301],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5
  }, {
    "p": [293, 88, -297],
    "s": [1, 1, 1],
    "l": 1,
    "c": "#000000",
    "e": "#e8b024",
    "t": 5
  }, {
    "p": [294, 88, -278],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5,
    "ab": 1
  }, {
    "p": [294, 87, -286],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5,
    "ab": 1
  }, {
    "p": [296, 85, -292],
    "s": [3, 3, 6],
    "l": 1,
    "c": "#c3a524",
    "t": 5
  }, {
    "p": [296, 85, -292],
    "s": [4, 2, 4],
    "l": 1,
    "c": "#c3a524",
    "t": 5
  }, {
    "p": [296, 88, -289],
    "s": [2, 3, 3],
    "l": 1,
    "c": "#c3a524",
    "t": 5
  }, {
    "p": [296, 88, -287],
    "s": [2, 1, 1],
    "l": 1,
    "c": "#ff9800",
    "t": 5
  }, {
    "p": [296, 89, -289],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [296, 88, -295],
    "s": [2, 1, 1],
    "l": 1,
    "c": "#c3a524",
    "t": 5
  }, {
    "p": [299, 96, -280],
    "s": [32, 1, 9],
    "i": 30,
    "r": [1.57, 0, 1.57],
    "st": "M",
    "bv": 1,
    "sf": 120
  }, {
    "p": [273, 76, -267],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, 1.05, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [273, 75, -314],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, 1.05, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [289, 75, -309],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [274, 75, -272],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [244, 67, -331],
    "s": [2, 5, 2],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [244, 67, -334],
    "s": [2, 5, 2],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [241, 71, -331],
    "s": [8, 2, 2],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [241, 71, -334],
    "s": [8, 2, 2],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [238, 71, -332],
    "s": [3, 9, 5],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [239, 80, -332],
    "s": [3, 3, 3],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [238, 71, -332],
    "s": [2, 8, 7],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [274, 78, -272],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5
  }, {
    "p": [273, 78, -267],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, 1.05, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5
  }, {
    "p": [289, 78, -309],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5,
    "ab": 1
  }, {
    "p": [273, 77, -314],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, 1.05, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5,
    "ab": 1
  }, {
    "p": [240, 71, -327],
    "s": [1, 1, 5],
    "l": 1,
    "c": "#283e09",
    "t": 5
  }, {
    "p": [240, 71, -324],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0.5, -0.17, -0.31],
    "c": "#3e0808",
    "t": 5
  }, {
    "p": [240, 71, -324],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0.8, 0.66, -0.39],
    "c": "#3e0808",
    "t": 5
  }, {
    "p": [240, 71, -324],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0.8, 0.66, -0.39],
    "c": "#3e0808",
    "t": 5
  }, {
    "p": [240, 71, -324],
    "s": [2, 1, 1],
    "l": 1,
    "c": "#3e0808",
    "t": 5
  }, {
    "p": [299, 75, -273],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [299, 78, -273],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5,
    "ab": 1
  }, {
    "p": [298, 75, -268],
    "s": [1, 2, 1],
    "l": 1,
    "r": [0, -0.26, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [298, 77, -268],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5,
    "ab": 1
  }, {
    "p": [290, 75, -277],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, -0.26, 0],
    "c": "#988e62",
    "t": 5
  }, {
    "p": [290, 78, -277],
    "s": [1, 1, 1],
    "l": 1,
    "r": [0, -0.26, 0],
    "c": "#000000",
    "e": "#e8b024",
    "t": 5,
    "ab": 1
  }, {
    "p": [-97, 93, -274],
    "s": [11, 0, 6],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "sad": 1
  }, {
    "p": [-95, 93, -274],
    "s": [11, 0, 6],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }, {
    "p": [98, 99, -219],
    "s": [12, 0, 7],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }, {
    "p": [96, 99, -219],
    "s": [12, 0, 7],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "sad": 1
  }, {
    "p": [12, 123, -378],
    "s": [63, 0, 29],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "sad": 1
  }, {
    "p": [12, 107, -381],
    "s": [67, 32, 4],
    "c": "#554235",
    "t": 5
  }, {
    "p": [-17, 89, -382],
    "s": [4, 52, 4],
    "l": 1,
    "c": "#554235",
    "t": 5
  }, {
    "p": [41, 89, -382],
    "s": [4, 52, 4],
    "l": 1,
    "c": "#554235",
    "t": 5
  }, {
    "p": [245, 122, -60],
    "s": [3, 32, 3],
    "l": 1,
    "c": "#554235",
    "t": 5
  }, {
    "p": [245, 122, -8],
    "s": [3, 32, 3],
    "l": 1,
    "c": "#554235",
    "t": 5
  }, {
    "p": [243, 124, -34],
    "s": [1, 28, 58],
    "c": "#554235",
    "t": 5
  }, {
    "p": [242, 138, -33],
    "s": [55, 0, 25],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "sad": 1
  }]
}